export enum StaticVideoType {
  default_RHP = 'default RHP',
  default_LHP = 'default LHP',
  empty_carousel = 'empty_carousel',
  screensaver = 'screensaver',
  training = 'training',
  training_short = 'training_short',
}

export enum TroubleshootingPitchID {
  // should match StaticVideoType.empty_carousel
  EmptyCarousel = 'empty_carousel',
  EjectBalls = 'eject-balls',
}

export enum WsMsgType {
  DEPR_S2M_PitchRecap = 'pitch-recap', // ! deprecate this type
  Firmware_Commit = 'fw-commit',
  Firmware_ConfigRead = 'fw-config-read',
  Firmware_ConfigWrite = 'fw-config-write',
  Firmware_Response = 'fw-response',
  Firmware_Upgrade = 'fw-upgrade',
  M2S_MachineStatusUpdate = 'machine-status-update',
  M2S_PreFire = 'pre-fire', // ! deprecated in AM, should be removed in TW too
  M2U_AutoCalibrateStarted = 'auto-calibrate-started',
  M2U_BallStatus = 'ball-status',
  M2U_CalibrateProgress = 'calibrate-progress',
  M2U_CalibrateStereo = 'calibrate-stereo-response', // ! deprecate this type
  M2U_CalibrationResponse = 'calibrationresponse',
  M2U_CameraStream = 'camera-stream', // ! deprecate this, user fetches the latest frame via REST on an interval instead
  M2U_FireResponse = 'fireresponse',
  M2U_HealthCheck = 'health-check-response',
  M2U_MachineHeartbeat = 'machine-heartbeat', // ! deprecate this if machines don't send it
  M2U_MachineReset = 'machine-reset',
  M2U_MsCurrent = 'mscurrent',
  M2U_OverlaysResponse = 'overlay-ids-response',
  M2U_ProjectorControlResponse = 'projector-control-response',
  M2U_QueryProcesses = 'query-processes-response',
  M2U_ReadLogResponse = 'read-log-response',
  M2U_ReadyToFire = 'r2f',
  M2U_SoftReboot = 'soft-reboot-response',
  M2U_SystemRestart = 'system-restart-response',
  M2U_TrainingResponse = 'trainingresponse',
  M2U_VisionCameraProgress = 'vision-camera-progress',
  M2U_VisionDistanceProgress = 'vision-distance-progress',
  M2U_VisionRemoteCalibrationResponse = 'vision-remote-calibration-response',
  Misc_ControlForce = 'control-force',
  Misc_ControlRequest = 'control-request',
  Misc_ControlResponse = 'control-response',
  Misc_CustomRequest = 'custom-request',
  Misc_CustomResponse = 'custom-response',
  Misc_Error = 'errormsg',
  Misc_MachineQueueState = 'machine-queue-state',
  Misc_ProjectorSoundFx = 'projector-sfx',
  Misc_UserConnection = 'user-connection', // ! deprecate, not sent or used anywhere in TW
  Misc_WebRTC_Answer = 'wrtc-answer', // todo: video streaming refactor
  Misc_WebRTC_Candidate = 'wrtc-candidate', // todo: video streaming refactor
  Misc_WebRTC_Offer = 'wrtc-offer', // todo: video streaming refactor
  Process_Kill = 'kill-process',
  Process_Query = 'query-processes',
  Process_RelayRestart = 'relay-restart',
  Process_Reset = 'reset-process',
  Process_TiltLutReset = 'tilt-lut-reset',
  Queue_ActivatedUser = 'activated-user', // ! deprecate, not used
  Queue_DeactivatedUser = 'deactivated-user',
  S2M_CalibrateAmpPosition = 'calibrate-amp-pos-on-install',
  S2M_CalibrateVentionPosition = 'calibrate-vention-unknown-state', // ! deprecate, not used
  S2M_ClearOverlays = 'clear-overlays',
  S2M_HitterDetails = 'hitter-details',
  S2M_PitchPreview = 'pitch-preview',
  S2M_PitchRecap = 'machine-pitch-recap',
  S2M_RestartFW = 'system-restart', // restart FW
  S2M_RestartOS = 'soft-reboot', // restart OS
  S2M_TailscaleKey = 'tailscale-key',
  S2M_TwoFa = '2fa',
  S2U_Announcement = 'announcement',
  S2U_BpSummary = 'bp-summary-response',
  S2U_Context = 'context',
  S2U_ForwardWs = 'fwd-ws',
  S2U_GameStatus = 'game-status',
  S2U_MachineDetails = 'machine-details-response',
  S2U_MachineLiveFires = 'machine-live-fires-response',
  S2U_MachineShotHistory = 'machine-shot-history-response',
  S2U_MachinesSummary = 'machines-summary-response',
  S2U_OnDemandStatus = 'on-demand-status',
  S2U_PitchRecap = 'user-pitch-recap',
  S2U_PitchRecapUpdate = 'user-pitch-recap-update',
  S2U_RealTimeTest = 'real-time-test',
  U2M_AutoFire = 'autofire',
  U2M_CalibrateStereo = 'calibrate-stereo-request',
  U2M_CameraStream = 'camera-stream-request', // ! deprecate, since calling the REST endpoint should now trigger the machine to start streaming automatically
  U2M_HealthCheck = 'health-check-request',
  U2M_PreviewVideo = 'preview-video',
  U2M_ProjectorControl = 'projector-control',
  U2M_ReadLog = 'read-log',
  U2M_SpecialMsTarget = 'special-mstarget',
  U2M_VisionCameraRequest = 'vision-camera-request',
  U2M_VisionDistanceRequest = 'vision-distance-request',
  U2M_VisionRemoteCalibrationRequest = 'vision-remote-calibration-request',
  U2S_BpSummary = 'bp-summary-request',
  U2S_Calibrate = 'calibrate',
  U2S_Dropball = 'dropball',
  U2S_EjectBalls = 'eject-balls',
  U2S_Fire = 'fire',
  U2S_ForwardWs = 'fwd-ws-request', // for start/stop forwarding msgs
  U2S_GameStatus = 'game-status-request', // user is listening for whether they are in a game
  U2S_Keystone = 'keystone', // ! deprecate if users always use projectors' keystone controls instead
  U2S_MachineDetails = 'machine-details-request',
  U2S_MachineLiveFires = 'machine-live-fires-request',
  U2S_MachineShotHistory = 'machine-shot-history-request',
  U2S_MachinesSummary = 'machines-summary-request',
  U2S_MsTarget = 'mstarget',
  U2S_Overlays = 'overlay-ids',
  U2S_ResendMsTarget = 'resend-mstarget',
  U2S_Ruler = 'ruler',
}

// messages from ws-bus to backend
export enum WsToBackendType {
  TrainingFailed = 'training-failed',
}

export const WS_MISC = [
  WsMsgType.Misc_ControlForce,
  WsMsgType.Misc_ControlRequest,
  WsMsgType.Misc_ControlResponse,
  WsMsgType.Misc_CustomRequest,
  WsMsgType.Misc_CustomResponse,
  WsMsgType.Misc_MachineQueueState,
  WsMsgType.Misc_ProjectorSoundFx,
  WsMsgType.Misc_UserConnection,
];

export const WS_FIRMWARE = [
  WsMsgType.Firmware_Commit,
  WsMsgType.Firmware_ConfigRead,
  WsMsgType.Firmware_ConfigWrite,
  WsMsgType.Firmware_Response,
  WsMsgType.Firmware_Upgrade,
];

export const WS_SERVER_TO_USER = [
  WsMsgType.S2U_Announcement,
  WsMsgType.S2U_Context,
  WsMsgType.S2U_GameStatus,
];

export const WS_QUEUE = [
  WsMsgType.Queue_ActivatedUser,
  WsMsgType.Queue_DeactivatedUser,
];

export const WS_PROCESS = [
  WsMsgType.Process_Kill,
  WsMsgType.Process_Query,
  WsMsgType.Process_Reset,
  WsMsgType.S2M_RestartOS,
  WsMsgType.S2M_RestartFW,
];

export const WS_SERVER_TO_MACHINE = [
  WsMsgType.DEPR_S2M_PitchRecap,
  WsMsgType.S2M_CalibrateAmpPosition,
  WsMsgType.S2M_CalibrateVentionPosition,
  WsMsgType.S2M_ClearOverlays,
  WsMsgType.S2M_HitterDetails,
  WsMsgType.S2M_PitchPreview,
  WsMsgType.S2M_PitchRecap,
  WsMsgType.S2M_TwoFa,
  ...WS_PROCESS,
  ...WS_QUEUE,
];

export const WS_MACHINE_TO_SERVER = [WsMsgType.M2U_CameraStream];

export const WS_MACHINE_TO_USER = [
  WsMsgType.M2U_BallStatus,
  WsMsgType.M2U_CalibrationResponse,
  WsMsgType.M2U_FireResponse,
  WsMsgType.M2U_MachineReset,
  WsMsgType.M2U_MsCurrent,
  WsMsgType.M2U_OverlaysResponse,
  WsMsgType.M2U_QueryProcesses,
  WsMsgType.M2U_ReadLogResponse,
  WsMsgType.M2U_ReadyToFire,
  WsMsgType.M2U_SoftReboot,
  WsMsgType.M2U_SystemRestart,
  WsMsgType.M2U_TrainingResponse,
  WsMsgType.Misc_Error,
];

export const WS_FROM_USER_TO_SERVER = [
  WsMsgType.U2S_Calibrate,
  WsMsgType.U2S_Dropball,
  WsMsgType.U2S_EjectBalls,
  WsMsgType.U2S_Fire,
  WsMsgType.U2S_Keystone,
  WsMsgType.U2S_MsTarget,
  WsMsgType.U2S_Overlays,
  WsMsgType.U2S_Ruler,
];

export const WS_FROM_USER_TO_MACHINE = [
  WsMsgType.U2M_CameraStream,
  WsMsgType.U2M_PreviewVideo,
  WsMsgType.U2M_ReadLog,
  WsMsgType.U2M_SpecialMsTarget,
];

export enum BallStatusMsgType {
  ActivatedUser = 'activated-user',
  AfterDropball = 'after-dropball',
  AfterFire = 'after-fire',
  AfterSend = 'after-send',
  Default = 'default',
  Mock = 'mock',
}

export enum MachineLogLevel {
  CRITICAL = 'CRITICAL',
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  INFO = 'INFO',
  DEBUG = 'DEBUG',
}

export enum CameraSource {
  BI_R = 'Ball Inserter (Right)', // ! deprecate to BI_RIGHT
  BI_RIGHT = 'BI_RIGHT',
  OD_L = 'Output Detector (Left)', // ! deprecate to OD_LEFT
  OD_LEFT = 'OD_LEFT',
  OD_T = 'Output Detector (Top)', // ! deprecate to OD_TOP
  OD_TOP = 'OD_TOP',
  BI_DEBUG = 'BI_DEBUG',
  SPIN_DETECTOR = 'SPIN_DETECTOR', // for 2026+ machines only
  STEREO_CHECK = 'STEREO_CHECK',
}

export enum ContextName {
  Videos = 'Videos',
}

export enum SfxName {
  START = 'start',
  NOT_READY = 'not_ready',
  DELAY_FIRE = 'delay_fire',
  FIRE = 'fire',
  ERROR = 'error',
  REMOTE = 'remote',
}

export enum FirmwareBranch {
  // use whatever branch the repo has checked out
  CURRENT = 'current',
  ROLLBACK = 'rollback',
  MAIN = 'main',
  BETA = 'beta',
  STAGING = 'staging',
  DEV = 'dev',
}

export enum HealthCheckType {
  FULL = 'full-health-check',
}

export enum QueueState {
  Active = 'Active',
  Busy = 'Busy',
  MachineDC = 'Machine Disconnected',
  UserDC = 'User Disconnected',
}

export const QUEUE_STATES_THAT_ALLOW_AUTO_FIRE = [QueueState.Active];
